import { createMuiTheme } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#213262" // "#46AD8D"
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contast with palette.primary.main
    },
    secondary: grey
  },
  status: {
    danger: "orange"
  },
  typography: {
    // Use the system font over Roboto.
    fontFamily: '"Poppins", sans-serif', //'Lato,Roboto,"Helvetica Neue",Arial,sans-serif',
    display1: {
      fontWeight: 200
    },
    display2: {
      fontWeight: 200
    },
    display3: {
      fontWeight: 200
    },
    display4: {
      fontWeight: 200
    }
  }
});

export default theme;
